import { render, staticRenderFns } from "./StaffChart.vue?vue&type=template&id=7ca9946a&scoped=true&"
import script from "./StaffChart.vue?vue&type=script&lang=js&"
export * from "./StaffChart.vue?vue&type=script&lang=js&"
import style0 from "./StaffChart.vue?vue&type=style&index=0&id=7ca9946a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca9946a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca9946a')) {
      api.createRecord('7ca9946a', component.options)
    } else {
      api.reload('7ca9946a', component.options)
    }
    module.hot.accept("./StaffChart.vue?vue&type=template&id=7ca9946a&scoped=true&", function () {
      api.rerender('7ca9946a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/StaffChart.vue"
export default component.exports